module.exports = __webpack_public_path__ + "media/src/assets/Images/mail-01-2705f4e217e937c1f03379a60f4fc28b.svg";